// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"a5f2ebcf","488":"140f568a","605":"c55a32c5","943":"0d5f0a3f"}[chunkId] + ".chunk.js";
};